import { Bank, PreferredAccountFormat } from "Infrastructure/Api/Api";
import type {
	BankDetailTranslations,
	FormTranslations,
	MutationTranslations,
	SelectOptionsTranslations,
	SharedTranslations,
	ValidationMessagesTranslations,
} from "Infrastructure/Translation/Types/bankDetail";

const mutationTranslations: MutationTranslations = {
	updateBankDetailError: "Failed to update bank detail",
	updateBankDetailSuccess: "Bank detail updated successfully",
	createBankDetailError: "Failed to create bank detail",
	createBankDetailSuccess: "Bank detail created successfully",
};

const sharedTranslations: SharedTranslations = {
	addBankDetail: "Add bank detail",
	editBankDetail: "Edit bank detail",
	bankDetails: "Bank details",
};

const formTranslations: FormTranslations = {
	name: "Name",
	bankName: "Bank name",
	bankAccount: "Bank account",
	iban: "IBAN",
	bankCode: "Bank code",
	preferredAccountFormat: "Preferred account format",
	cancel: "Cancel",
	save: "Save",
};

const selectOptionsTranslations: SelectOptionsTranslations = {
	banks: {
		[Bank.fio]: "Fio banka, a.s.",
		[Bank.revolut]: "Revolut Bank",
		[Bank.raiffeisenbank]: "Raiffeisenbank a.s.",
	},
	preferredAccountFormat: {
		[PreferredAccountFormat.bank_account_number]: "Bank account number",
		[PreferredAccountFormat.iban]: "IBAN",
	},
};

const validationMessagesTranslations: ValidationMessagesTranslations = {
	name: "Name is required",
	bankName: "Bank name is required",
	bankAccount: "Bank account is required",
	iban: "IBAN is required",
	bankCode: "Bank code is required",
};

export const bankDetailTranslations: BankDetailTranslations = {
	mutations: mutationTranslations,
	shared: sharedTranslations,
	form: formTranslations,
	selectOptions: selectOptionsTranslations,
	validationMessages: validationMessagesTranslations,
};
